export default __webpack_public_path__ + "static/gb-numberplate-5e0879a76fc53fc48f347ff03576a2e0.svg";